//import merge from 'lodash-es/merge'
//import merge from 'deepmerge'

//import isEmpty from 'lodash-es/isEmpty';

// import * as turf from '@turf/turf'
import { point } from'@turf/helpers'
import distance from '@turf/distance'
//import pointToLineDistance from '@turf/point-to-line-distance'
//import oktSimple from "./okt_simple.geojson"

// TODO: isPointNearby as a config 
import { isPointNearby } from '../util/geo-filter-kektura-21.js'

import * as ActionTypes from './viewportActions'
import {FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS, FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR,
       SET_DISPLAY_TIME_FILTERING }
        from './viewportItemActions'
import {FETCH_GEOJSON_SUCCESS, SET_VIEWPORT_ITEM_ZOOM_TO} 
        from './uiActions'

import {SET_EXTRA_MAP_FEATURES, SET_EXTRA_MAP_FEATURES_VISIBILITY, 
        REMOVE_MAP_MARKER_FEATURE } from './viewportActions.js'

//import uiReducer from './ui'

function isEmpty(value) {
  if (value == null) return true;

  if (Array.isArray(value) || typeof value === 'string') {
      return value.length === 0;
  }

  for (let key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key))
          return false;
  }
  return true;
}

const initialState = {
  viewport: {}, // viewportItemId -> moStateTimeout
  // to retain states before adapting to the filtering time: 
  itemMoFetchedLastStates: {}, // viewportItemId -> moState  
  itemMoLastStates: {}, // viewportItemId -> moState
  itemMoFirstStates: {}, // viewportItemId -> moState
  itemMoStats: {}, // viewportItemId -> generic statistics
  itemMoLocations: {}, // viewportItemId -> moTrajectory
  // to retail all locations before filtering out non-visible ones: 
  // itemMoFetchedLocations: {}, // viewportItemId -> moTrajectory
  extraMapFeatures: {},
  extraMapFeaturesVisibility: {}, 
  mapLayers: {},
  geoJsons: {}
}

const viewportReducer = (state = initialState, action) => {
  // console.log("viewportReducer: " + action.type)
  switch (action.type) {
    case ActionTypes.FETCH_VIEWPORT_REQUEST:
      return state
    case ActionTypes.FETCH_VIEWPORT_ERROR:
      console.log('FETCH_VIEWPORT_ERROR: ', action)
      return state
    case ActionTypes.FETCH_VIEWPORT_SUCCESS:
      //return merge( {}, state, { viewport: action.response.data } )
      //return merge(state, { viewport: action.response.data });
      return {
        ...state,
        viewport: action.response.data
      }

    case FETCH_VIEWPORT_ITEM_BASIC_INFO_SUCCESS:
      if ( !(action.infoResponse) || isEmpty(action.infoResponse.data) ) return state

      var ret = {
        ...state,
        itemMoLocations: {
          ...state.itemMoLocations,
          [action.viewportItemId]: updateLocationDerivates( mergeLocations(
            state.itemMoLocations[action.viewportItemId],
            filterLocations( action.infoResponse.data.locations, action.viewportItemId) ) )
        },
        itemMoLastStates: {
          ...state.itemMoLastStates,
          [action.viewportItemId]: updateLastState(action.infoResponse.data.lastState)
        },
        // TODO: itemMoLastStates should be enough 
        itemMoFetchedLastStates: {
          ...state.itemMoFetchedLastStates,
          [action.viewportItemId]: updateLastState(action.infoResponse.data.lastState)
        }         
      }
      if (! isEmpty(action.infoResponse.data.firstState)) {
        ret = {
          ...ret,
          itemMoFirstStates: {
            ...state.itemMoFirstStates,
            [action.viewportItemId]: action.infoResponse.data.firstState
          }
        }
      }
      if (! isEmpty(action.infoResponse.data.locations)) {
        var stats = computeItemStats(
          ret.itemMoLocations[action.viewportItemId],
          ret.itemMoFirstStates[action.viewportItemId],
          ret.itemMoLastStates[action.viewportItemId]
        )
        ret =  {
          ...ret,
          itemMoStats: {
            ...state.itemMoStats,
            [action.viewportItemId]: stats
          }
        }
      } 
      return ret

    case FETCH_VIEWPORT_ITEM_BASIC_INFO_ERROR:
      console.log("ERROR: cannot fetch viewport item basic info. " + action.error )
      return state 
      
    case SET_EXTRA_MAP_FEATURES:
      return {
        ...state,
        extraMapFeatures: action.features
      }

    case SET_EXTRA_MAP_FEATURES_VISIBILITY:
      if (action.key) {
        return {
          ...state,
          extraMapFeaturesVisibility: {
            ...state.extraMapFeaturesVisibility,
            [action.key]: action.visibility
          }
        }  
      }
      else if (action.visibilities) {
        return {
          ...state,
          extraMapFeaturesVisibility: action.visibilities
        }
      }
      else {
        return state
      }


    case SET_VIEWPORT_ITEM_ZOOM_TO: 
      return {
        ...state, 
        mapLayers: {
          ...state.mapLayers,
          [action.layerId]: {
            ...state.mapLayers[action.layerId], 
            [action.viewportItemId]: action.feature 
          }
        }
      }

    case REMOVE_MAP_MARKER_FEATURE: 
      return {
        ...state
      }
    
    case FETCH_GEOJSON_SUCCESS: 
      return {
        ...state, 
        geoJsons: {
          ...state.geoJsons, 
          [action.itemKey]: action.geoJson
        }
      }

    case SET_DISPLAY_TIME_FILTERING:
      var distSumKm = 0 

      for (const itemid in state.itemMoLastStates) {
        // TODO: distsum using timestamps and full trajectory

        //const locs = filterLocationsOnTime( state.itemMoFetchedLocations[itemid], action.displayTime )
        // if (itemid in state.itemMoLocations) 
        distSumKm = distSumKm + computeDistSum( state.itemMoLocations[itemid], 
                                                action.displayTime.timeTo )
        //console.log(new Date(action.displayTime.timeTo), " distSumKm: ", distSumKm)
        if (state.itemMoFetchedLastStates && itemid in state.itemMoFetchedLastStates) { 
          state = 
          {
            ...state,
            //itemMoLocations: {
            //  ...state.itemMoLocations,
            //  [itemid]:  locs
            //},
            itemMoLastStates: {
              ...state.itemMoLastStates,
              [itemid]: updateLastStateWithTime( state.itemMoFetchedLastStates[itemid],  
                                                 state.itemMoLocations[itemid], action.displayTime)
              //[itemid]: updateLastState(action.infoResponse.data.lastState)
            }
          }
        }
        //console.log(itemid)
      }   
      state = 
      {
        ...state, 
        distSumKm: distSumKm / 1000
      }
      return state 
      //return {
      //  ...state,
      //  itemMoLocations: {
      //    ...state.itemMoLocations,
      //    [action.viewportItemId]: updateLocationDerivates( mergeLocations(
      //      state.itemMoLocations[action.viewportItemId],
      //      filterLocations( action.infoResponse.data.locations, action.viewportItemId) ) )
      //  },
      //  itemMoLastStates: {
      //    ...state.itemMoLastStates,
      //    [action.viewportItemId]: updateLastState(action.infoResponse.data.lastState)
      //  }
      //}      

    default:
      return state
  }
}

export function mergeLocations(older, newer) {
  //var start = window.performance.now();
  
  if (! older) return newer ;
  if (! newer) return older ;
  // older.concat(newer).unique();
  var i=0
  var j=0
  var merged = []

  while (i < older.length || j < newer.length) {
    //console.log("indexes:", i, j, "lengths: ", older.length, newer.length)

    if (i < older.length && j < newer.length) {
      if (older[i].time < newer[j].time) {
        merged.push(older[i])
        i++
      }
      else if (older[i].time == newer[j].time) {
        merged.push(newer[j])
        j++ ;
        i++ ;
      }
      else if (older[i].time > newer[j].time) {
        merged.push(newer[j])
        j++ ;
      }
    }
    else if (i < older.length && j == newer.length) {
      merged.push(older[i])
      i++
    }
    else if (i == older.length && j < newer.length) {
      merged.push(newer[j])
      j++ ;
    }
  }
  //var end = window.performance.now();
  //console.log(itemid, 'merging finished:', older.length, "+", newer.length, 
  //            ` in ${end - start} ms`)
  return merged
}

function filterLocations(locs, itemid) {
  if (! locs) return locs; 
  if ((typeof TRAJECTORY_FILTER_LOCATIONS !== "undefined") && (! TRAJECTORY_FILTER_LOCATIONS)) return locs;  

  // lodash: 
  //remove(locs, function(n) {
  //  // TODO: hardwired
  //  return ( ! isPointNearby(n.lon, n.lat, 0.25) ) ;
  //});
  //return locs ;
  // var ret = locs ;
  // JS array: 
  // TODO: filtering from config 
  var ret = locs.filter(function(value){ 
    return isPointNearby(value.lon, value.lat, 0.1);
  });
  //console.log(itemid, 'filtering finished:', locs.length, "->", ret.length)
  //            ` in ${end - start} ms`)
  return ret ;
}

function getLastLocationOfTimeRange(locs, displayTime) {
  if (locs?.length>0) {
    // binary search (timestamps increase monotically): 
    let recursiveFunction = function (locs, targetTime, startIndex, endIndex) {
      if (startIndex > endIndex) return endIndex;  
      // Find the middle index
      let mid=Math.floor((startIndex + endIndex)/2);
      // Compare mid with given key x
      if ( (locs[mid].time>targetTime && mid>=1 && locs[mid-1]<=targetTime)|| 
          (locs[mid].time>targetTime && mid<=1) )  
        return mid;
      if(locs[mid].time > targetTime)
        return recursiveFunction(locs, targetTime, startIndex, mid-1);
      else
        return recursiveFunction(locs, targetTime, mid+1, endIndex);
    } 

    //var i1 = recursiveFunction(locs, displayTime.timeFrom, 0, locs.length-1)
    var i2 = recursiveFunction(locs, displayTime.timeTo, 0, locs.length-1)
    return locs[i2] // .slice(i1, i2)
  } 
  else return null 

  // var i1 = 0 
  // var i2 = 0
  // for (var i = 0; i < locs.length; i++) {  
  //   if (displayTime.timeFrom && locs[i].time <= displayTime.timeFrom) i1 = i
  //   if (displayTime.timeTo && locs[i].time <= displayTime.timeTo) i2 = i
  // }
  // return locs.slice(i1, i2)

  //var locs2 = []
  //// alt, distPrev, gpsPace, lat, lon, pacePrev, time, timeDiffPrev
  //for (var i = 0; i < locs.length; i++) { 
  //  //console.log(displayTime.timeFrom, locs[i].time, displayTime.timeTo )
  //  if ( (! displayTime.timeFrom ||  locs[i].time >= displayTime.timeFrom) &&
  //       (! displayTime.timeTo ||  locs[i].time <= displayTime.timeTo) ) {
  //    locs2.push(locs[i])
  //    
  //  }
  //}
  //return locs2     
  
}

function updateLastState(state) {
  // transform gps speed
  //if (state.speed==0) state.gpsPace = 0
  //else
  state.gpsPace = ( 1.0 / (state.speed/60.0))
  delete state.speed;
  return state
}

function updateLastStateWithTime( fetchedState, locs, displayTime)  {
  var ret = fetchedState 
  const lastLoc = getLastLocationOfTimeRange(locs, displayTime)

  if (locs && (locs[locs.length -1])) {
    ret = {
      ...fetchedState, 
      lat: lastLoc.lat, 
      lon: lastLoc.lon
    }  
  }
  else {
    ret = {
      ...fetchedState, 
      lat: null, 
      lon: null
    }
  }
  return ret
}

export function updateLocationDerivates(locs) {
  if (locs==null) return locs
  for (var i = 0; i < locs.length; i++) {
    // transform gps speed
    locs[i].gpsPace = ( 1.0 / (locs[i].speed/60.0))
    delete locs[i].speed;
    // compute distance and pace
    if (i==0) {
      locs[i].timeDiffPrev = null ;
      locs[i].distPrev = null ;
      locs[i].pacePrev = null ;
    }
    // if there are two points to compute distance
    if (i-1 >= 0 && locs.length >1) {
      // TODO: distance compensation factor
      locs[i].distPrev = 1000 * distance(
        point([locs[i-1].lon, locs[i-1].lat]),
        point([locs[i].lon, locs[i].lat]), {units: 'kilometers'}) *1.007
      locs[i].timeDiffPrev = locs[i].time - locs[i-1].time
      locs[i].pacePrev = locs[i].timeDiffPrev / (locs[i].distPrev*60.0)
    }
    //console.log(moment(locs[i].time).format(),
    //  locs[i].lat, locs[i].lon, locs[i].alt, locs[i].timeDiffPrev,
    //  (locs[i].distPrev / (locs[i].timeDiffPrev/1000) ) )
  }
  //console.log("LOCS:", locs)
  return locs

}

// compute the overall distance of all the trajectories up to a certain time point
function computeDistSum(locs, timeTo) {
  if (locs==null) return 0
  // console.log(locs[0].time, timeTo)
  var kmsum = 0
  for (var i = 0; i < locs.length && locs[i].time <= timeTo; i++) {
    if (i-1 >= 0 && locs.length >1) {
      // TODO: distance compensation factor
      kmsum = kmsum + 1000 * distance(
        point([locs[i-1].lon, locs[i-1].lat]),
        point([locs[i].lon, locs[i].lat]), {units: 'kilometers'}) 
        *1.007*0.884509938
    }
  }
  return kmsum
}

function computeItemStats(locs, firstState, lastState) {
  var ret = {}
  if (firstState != null) ret.timeFull = lastState.time - firstState.time ;
  if (locs != null ) {
    var distFull = 0
    var paceMin = 99999 ;
    var stopTime = 0 ;
    for (var i = 0; i < locs.length; i++) {
      distFull += locs[i].distPrev
      if (locs[i].pacePrev && paceMin > locs[i].pacePrev)
        paceMin = locs[i].pacePrev
      // stop time: if distance < 1m
      if (locs[i].distPrev < 2.0) stopTime += locs[i].timeDiffPrev
    }
  }
  // adjust distance:
  if (TRAJECTORY_DISTANCE_ADJUSTMENT ) distFull = distFull * TRAJECTORY_DISTANCE_ADJUSTMENT ;

  var paceAvg = null;
  if (ret.timeFull != null) paceAvg = ret.timeFull / (distFull*60.0)
  ret.distFull=distFull
  ret.paceMin = paceMin
  ret.stopTime = stopTime
  ret.paceAvg = paceAvg
  return ret
}


export default viewportReducer
